import { render, staticRenderFns } from "./CancelProfileForm.vue?vue&type=template&id=0d327d22&scoped=true&"
import script from "./CancelProfileForm.vue?vue&type=script&lang=js&"
export * from "./CancelProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./CancelProfileForm.vue?vue&type=style&index=0&id=0d327d22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d327d22",
  null
  
)

export default component.exports